import { render, staticRenderFns } from "./pendingapproval.vue?vue&type=template&id=709b8162"
import script from "./pendingapproval.vue?vue&type=script&lang=js"
export * from "./pendingapproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports